import { FunctionComponent } from "react";

import { ListSourceType } from "@/enum/list.enum";

import { CustomEvent } from "@/pages/Private/pages/CustomEvent/schema/customEvent";
import { Map } from "@/pages/Private/pages/Map/schema/map";
import { CsvEnrichment } from "@/pages/Private/pages/CsvEnrichment/schema/csvEnrichment";
import { Job } from "@/pages/Private/pages/Job/schema/job";
import { LiCompanyActivity } from "@/pages/Private/pages/LiCompanyActivity/schema/liCompanyActivity";
import { LiEvent } from "@/pages/Private/pages/LiEvent/schema/liEvent";
import { LiPeople } from "@/pages/Private/pages/LiPeople/schema/liPeople";
import { LiPost } from "@/pages/Private/pages/LiPost/schema/liPost";
import { LiProfileVisits } from "@/pages/Private/pages/LiProfileVisits/schema/liProfileVisits";
import { CreateJobForm } from "@/pages/Private/pages/Job/components/CreateJobForm";

import { LiSn } from "@/pages/Private/pages/LiSn/schema/liSn";

import { StepInfo } from "@/components/StepInfo/StepInfo";

import { AddedSourceList } from "../../../components/AddedSourceList";
import { List } from "../../../schema/list";
import { FundingMa } from "../../../../FundingMa/schema/funding-ma";
import { Swarm } from "../../../../Swarm/schema/swarm";

export interface JobsSourceProps {
	data: List;
	duplicated:
		| Map
		| Job
		| CsvEnrichment
		| LiEvent
		| LiCompanyActivity
		| LiPost
		| LiProfileVisits
		| LiPeople
		| LiSn
		| FundingMa
		| Swarm
		| null;
	selected:
		| Map
		| Job
		| CsvEnrichment
		| LiEvent
		| LiCompanyActivity
		| LiPost
		| LiProfileVisits
		| LiPeople
		| CustomEvent
		| LiSn
		| FundingMa
		| Swarm
		| null;
	setDuplicated: (
		map:
			| Map
			| Job
			| CsvEnrichment
			| LiEvent
			| LiCompanyActivity
			| LiPost
			| LiProfileVisits
			| LiPeople
			| LiSn
			| FundingMa
			| Swarm
			| null
	) => void;
	setSelected: (
		map:
			| Map
			| Job
			| CsvEnrichment
			| LiEvent
			| LiCompanyActivity
			| LiPost
			| LiProfileVisits
			| LiPeople
			| LiSn
			| CustomEvent
			| FundingMa
			| Swarm
			| null
	) => void;
}

export const JobsSource: FunctionComponent<JobsSourceProps> = ({
	data,
	duplicated,
	selected,
	setDuplicated,
	setSelected,
}) => {
	if (data.sourceType === ListSourceType.JOBS) {
		return (
			<>
				<StepInfo
					description={
						<>
							<p>
								You start by entering a role or skill and a single country and specify if the role
								or skill it must appear in the job title. Next you define who you want to reach out
								to. You can layer on ICP filters like minimum employee count or HQ location, choose
								a one-time or daily refresh, and decide whether to include email addresses.
							</p>
						</>
					}
					title="Build a list of companies hiring for roles"
					videoId="EKuTo5_7MG8"
				/>
				<div className="flex flex-row gap-8">
					<div className="grow relative w-1/2">
						{duplicated ? (
							<CreateJobForm
								handleDuplicate={setDuplicated}
								handleSelect={setSelected}
								job={duplicated as Job}
								list={data as List}
							/>
						) : selected ? (
							<CreateJobForm handleSelect={setSelected} job={selected as Job} list={data as List} />
						) : (
							<CreateJobForm list={data as List} />
						)}
					</div>
					<div className="w-1/2">
						<AddedSourceList
							handleDuplicate={(item) => {
								setDuplicated(item);
								setSelected(null);
							}}
							handleSelect={(item) => {
								setSelected(item);
								setDuplicated(null);
							}}
							list={data as List}
						/>
					</div>
				</div>
			</>
		);
	}

	return <></>;
};
